function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M28.91,5.82h5.461a.91.91,0,1,0,0-1.82H28.91a.91.91,0,0,0,0,1.82Z",
  transform: "translate(-2.516 -0.359)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M38.91,5.82h1.82a.91.91,0,1,0,0-1.82H38.91a.91.91,0,1,0,0,1.82Z",
  transform: "translate(-3.414 -0.359)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M8.91,19.82H17.1a.91.91,0,0,0,0-1.82H8.91a.91.91,0,1,0,0,1.82Z",
  transform: "translate(-0.719 -1.617)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M22.91,19.82H36.562a.91.91,0,1,0,0-1.82H22.91a.91.91,0,0,0,0,1.82Z",
  transform: "translate(-1.977 -1.617)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M37.1,23H28.91a.91.91,0,0,0,0,1.82H37.1a.91.91,0,1,0,0-1.82Z",
  transform: "translate(-2.516 -2.067)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M8.91,24.82H22.562a.91.91,0,1,0,0-1.82H8.91a.91.91,0,1,0,0,1.82Z",
  transform: "translate(-0.719 -2.067)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M18.012,28.91A.91.91,0,0,0,17.1,28H8.91a.91.91,0,1,0,0,1.82H17.1A.91.91,0,0,0,18.012,28.91Z",
  transform: "translate(-0.719 -2.516)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M36.562,28H22.91a.91.91,0,0,0,0,1.82H36.562a.91.91,0,1,0,0-1.82Z",
  transform: "translate(-1.977 -2.516)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M50.058,3.641H41.776A4.559,4.559,0,0,0,37.316,0H12.742A.91.91,0,0,0,12.1.267L.267,12.1A.91.91,0,0,0,0,12.742V46.417a4.556,4.556,0,0,0,4.551,4.551h8.282a4.559,4.559,0,0,0,4.46,3.641H50.058a4.556,4.556,0,0,0,4.551-4.551V8.191A4.556,4.556,0,0,0,50.058,3.641ZM38.226,43.687v-.455a1.365,1.365,0,0,0-1.365-1.365H27.3V38.226h9.557a1.365,1.365,0,0,0,1.365-1.365v-.455l4.855,3.641ZM11.832,3.107V9.1a2.73,2.73,0,0,1-2.73,2.73H3.107ZM1.82,46.417V13.652H9.1A4.556,4.556,0,0,0,13.652,9.1V1.82H37.316a2.73,2.73,0,0,1,2.73,2.73V35.5L38.59,34.4A1.365,1.365,0,0,0,36.406,35.5v.91H26.849a1.365,1.365,0,0,0-1.365,1.365v4.551a1.365,1.365,0,0,0,1.365,1.365h9.557v.91a1.365,1.365,0,0,0,2.184,1.092L40.046,44.6v1.82a2.73,2.73,0,0,1-2.73,2.73H4.551A2.73,2.73,0,0,1,1.82,46.417Zm50.968,3.641a2.73,2.73,0,0,1-2.73,2.73H17.293a2.73,2.73,0,0,1-2.563-1.82H37.316a4.556,4.556,0,0,0,4.551-4.551V43.232l2.791-2.093a1.365,1.365,0,0,0,0-2.184l-2.791-2.093V30.945h5.461a.91.91,0,0,0,0-1.82H41.867v-2.73h5.461a.91.91,0,0,0,0-1.82H41.867v-2.73h5.461a.91.91,0,1,0,0-1.82H41.867V9.1H44.6a.91.91,0,1,0,0-1.82h-2.73V5.461h8.191a2.73,2.73,0,0,1,2.73,2.73Z",
  transform: "translate(0)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M54.73,8H52.91a.91.91,0,0,0,0,1.82h1.82a.91.91,0,0,0,0-1.82Z",
  transform: "translate(-4.672 -0.719)"
}));

function SvgMultiple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.609,
    height: 54,
    fill: "black",
    viewBox: "0 0 54.609 54.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiple);
export default __webpack_public_path__ + "static/media/Multiple.6dab7597.svg";
export { ForwardRef as ReactComponent };